import React, { useEffect, useState } from 'react'
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom'

import Home           from './pages/Home'
import AdminDashboard from './components/AdminDashboard'
import PinnedFAQsPage from './components/PinnedFAQPage'
import ForgotPassword from './components/ForgotPassword'
import ResetPassword  from './components/ResetPassword'
import Footer         from './components/Footer'

import { getCurrentUser, fetchCompanySetting, logoutUser } from './utils/api'
import { applyCustomCss } from './utils/branding'

function App() {
  const [userIsLoggedIn, setUserIsLoggedIn] = useState(false)
  const [branding, setBranding]             = useState(null)
  const navigate = useNavigate()

  // ————————————————————————————
  // On mount: “prime” Rails CSRF & load branding
  // ————————————————————————————
  useEffect(() => {
    async function boot() {
      try {
        // 1) GET /current_user, Rails will set XSRF-TOKEN in a cookie
        const user = await getCurrentUser()
        if (!user) throw new Error('Not logged in')
        setUserIsLoggedIn(true)
        // wait a few milliseconds just to ensure the browser has written the cookie
        await new Promise(resolve => setTimeout(resolve, 10))

        // 2) Now that we’re logged in (or had a valid session),
        //    fetch company settings as well:
        const settings = await fetchCompanySetting()
        setBranding(settings)
        applyCustomCss(settings.custom_css || '')
      } catch {
        // If the GET fails (not logged in, 401, or no CSRF cookie yet),
        // we still want Rails to drop XSRF-TOKEN (because the GET triggered after_action).
        setUserIsLoggedIn(false)
        applyCustomCss('')
      }
    }
    boot()
  }, [])

  const handleBrandingChange = newSettings => {
    setBranding(newSettings)
    applyCustomCss(newSettings.custom_css || '')
  }

  const handleLogout = async () => {
    await logoutUser()
    setUserIsLoggedIn(false)
    navigate('/')
  }

  return (
    <div className="app-container">
      <div className="content">
        <Routes>
          <Route
            path="/"
            element={
              <Home
                branding={branding}
                onBrandingChange={handleBrandingChange}
                onLogout={handleLogout}
              />
            }
          />
          <Route
            path="/pinned"
            element={
              <PinnedFAQsPage
                branding={branding}
                onBrandingChange={handleBrandingChange}
                onLogout={handleLogout}
              />
            }
          />
          <Route
            path="/dashboard"
            element={
              <AdminDashboard
                branding={branding}
                onBrandingChange={handleBrandingChange}
                onLogout={handleLogout}
              />
            }
          />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
      <Footer showCompanyName={userIsLoggedIn} />
    </div>
  )
}

export default App
